// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LevelProgressBar__outerProgressBar___jJ15d {
    margin: 0;
    border-radius: 1px;
    background: rgba(4, 5, 8, 0.72);
    border-top: 1px solid rgba(175, 133, 67, 0.18);
    border-bottom: 1px solid rgba(0, 0, 0, 0.72);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.78);
    position: fixed;
    top: 41px;
    left: calc(6vw - 4px);
    right: 6vw;
    height: 3px;
}

@keyframes LevelProgressBar__levelProgressShimmer___u50b_ {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: 0 0;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerProgressBar": `LevelProgressBar__outerProgressBar___jJ15d`,
	"levelProgressShimmer": `LevelProgressBar__levelProgressShimmer___u50b_`
};
module.exports = ___CSS_LOADER_EXPORT___;
